const initPagesSliderWidget = () => {
    const selectorString = "[data-pages-slider-widget] [data-carousel]";
    const carousel = document.querySelector(selectorString);
    if (carousel) {
        const config = new CarouselConfig();
        config.sliderSelector = selectorString;
        config.cellAlign = window.innerWidth > 767 ? CellAlign.left : CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = true;
        config.showArrows = false;
        config.showArrows = false;
        config.showDots = window.innerWidth <= 767 ? true : false;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        config.activateCustomButtons = window.innerWidth > 767 ? true : false;
        const responsiveCarousel = new ResponsiveCarousel();
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
    }
};
